import { render, staticRenderFns } from "./SurveyOption.vue?vue&type=template&id=0fba9cec&scoped=true&"
import script from "./SurveyOption.vue?vue&type=script&lang=js&"
export * from "./SurveyOption.vue?vue&type=script&lang=js&"
import style0 from "./SurveyOption.vue?vue&type=style&index=0&id=0fba9cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba9cec",
  null
  
)

export default component.exports